import { render, staticRenderFns } from "./manage_shipping_address.vue?vue&type=template&id=a2991460&"
import script from "./manage_shipping_address.vue?vue&type=script&lang=js&"
export * from "./manage_shipping_address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports